import BaseCheckbox from "../FormFields/Checkbox/BaseCheckbox";
import BaseTag from "../Tags/BaseTag";
import { CheckboxListItemProps } from "./types";

import "./styles.css";

const CheckboxListItem = (item: CheckboxListItemProps) => {
  const handleChange = (checked: boolean) => {
    if (item.onChange) {
      item.onChange(checked);
    }
  };

  return (
    <div
      className={`checkbox-list-item flex justify-between items-center ${item.isDisabled ? "disabled" : ""}`}
    >
      <div className="flex gap-200">
        {item.showCheckbox ? (
          <BaseCheckbox
            label={item.label}
            checked={item.checked}
            onChange={handleChange}
            className="flex items-center body-s-medium"
          />
        ) : (
          <span className="body-s-medium">{item.label}</span>
        )}

        {item.tagLabel && <BaseTag label={item.tagLabel} size="small" />}
      </div>

      <span className="body-s-regular">{item.description}</span>
    </div>
  );
};

export default CheckboxListItem;
